import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const FeaturesCard = () => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 py-0 lg:py-2.5  lg:border-b-2 border-gray-200 px-4 lg:px-0">
        <div className="col-span-1 flex items-center shadow-md lg:shadow-none rounded-lg lg:rounded-none">
            <img src="/images/offer.png" className="h-20 w-20" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">Remises d'opportunité</h2>
                <p className="text-gray-400 text-sm">Tasigförsamhet entre le design. Paiement mobile. Ylig kärrtorpa.</p>
            </div>
        </div>
        <div className="col-span-1 flex items-center shadow-md lg:shadow-none rounded-lg lg:rounded-none">
            <img src="/images/reduction.png" className="h-20 w-20" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">Codes de réduction</h2>
                <p className="text-gray-400 text-sm">Tasigförsamhet entre le design. Paiement mobile. Ylig kärrtorpa.</p>
            </div>
        </div>
        <div className="col-span-1 flex items-center shadow-md lg:shadow-none rounded-lg lg:rounded-none">
            <img src="/images/livraison.png" className="h-20 w-20" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">Livraison presque gratuite</h2>
                <p className="text-gray-400 text-sm">Tasigförsamhet entre le design. Paiement mobile. Ylig kärrtorpa.</p>
            </div>
        </div>
        <div className="col-span-1 flex items-center shadow-md lg:shadow-none rounded-lg lg:rounded-none">
            <img src="/images/payement.png" className="h-20 w-20" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">Paiement sécurisées</h2>
                <p className="text-gray-400 text-sm">Tasigförsamhet entre le design. Paiement mobile. Ylig kärrtorpa.</p>
            </div>
        </div>
    </div>
  );
};

export default FeaturesCard; 